import BefehlFormAuftrag from '../Generic/BefehlFormAuftrag'
import { useTranslation } from 'react-i18next'

export interface Auftrag3_10FormProps {
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag3_10Form({
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag3_10FormProps>) {
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="3.10"
      label={t('auftraege.3_10.label')}
      fieldName="auftrag_3_10.enabled"
      readOnly={true}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.3_10.label')}</span>
    </BefehlFormAuftrag>
  )
}
